import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'
import en from './locales/en/common.json'
import nl from './locales/nl/common.json'
import de from './locales/de/common.json'

i18next.use(initReactI18next).init({
  resources: {
    en: { common: en },
    nl: { common: nl },
    de: { common: de },
  },
  lng: 'en',
  fallbackLng: 'en',
  defaultNS: 'common',
  interpolation: { escapeValue: false },
})

export default i18next
